import { Component,Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ItemFormat } from '../../../shared/models/itemFormat.model';
import { DirectSessionLogicService } from '../../../shared/direct-session-logic.service';
import { SharedModule } from '../../../shared/shared.module';


@Component({
  selector: 'app-dynamic-payment-component-line-item',  
  template: `
    <section class="item-selection">
      <div class="item-selection__header ">
        <hr>
          <!-- <p class="item-description-details" aria-label="Description for item selection step">{{itemFormat.Discription}}</p> -->
          
          <div class="d-flex col justify-content-between">

            <div class="row-2" >
              <div class="item-description-title" aria-label="Title for item selection step">
                <img name="remove-option" style="cursor: pointer; width: 20px;" (click)="removeItemFromTotal(itemFormat)" *ngIf="!itemFormat.isFixed"
                  class="remove-option"
                  src="assets/Icons/x-circle.svg" alt="remove option"
                />
                {{itemFormat.cartName}}
              </div>
            </div >
            
            <div class="row-10 float-end">
              @if (!itemFormat.priceAsWholeNumber) {
                <div class="inline-block item-description-price">
                  $ {{itemFormat.price}} / month
                </div>
              }
              
              @if (itemFormat.priceAsWholeNumber) {
                <div class="inline-block item-description-price">
                  $ {{itemFormat.price}}.00 / month
                </div>
              }
            </div>

          </div>
      </div>
    </section>
  `,
  styleUrls: ['./dynamic-payment-component-line-item.component.scss'],
  standalone: true,
  imports: [ CommonModule, SharedModule],
})
export class DynamicPaymentComponentLineItemComponent {
  @Input() itemFormat!: ItemFormat;

  constructor(
    public directSessionLogic: DirectSessionLogicService
  ){
  }

  removeItemFromTotal(item: ItemFormat) {
    this.directSessionLogic.removeItemFromCartItemsSignal(item);
  }

  addItemToTotal(item: ItemFormat) {
    this.directSessionLogic.addItemToCartItemsSignal(item);
  }
}
